<script setup lang="ts">
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'

import { InputPrimary } from '@shared/ui/fields'
import { BtnIcon } from '@shared/ui/buttons'

defineOptions({
  name: 'LessonBalanceAvailable',
})

/** The paid lessons left to book, shown as a read-only field so it sits in a form row like the controls beside it,
 *  with the way to the discipline's Balance tab beside it for topping the balance up. */
withDefaults(defineProps<{
  value: number
  disabled?: boolean
}>(), {
  disabled: false,
})

const emit = defineEmits<{
  open: []
}>()
</script>

<template>
  <div class="lesson-balance-available">
    <InputPrimary
      id="lessons_available_for_booking"
      class="lesson-balance-available__field"
      label="Lessons available for booking"
      :value="String(value)"
      type="text"
      readonly
    />
    <BtnIcon
      :icon="faArrowUpRightFromSquare"
      color="blue"
      tooltip-text="Discipline balance"
      :disabled="disabled"
      @click="emit('open')"
    />
  </div>
</template>

<style scoped lang="scss" src="./LessonBalanceAvailable.scss" />
